<template>
  <router-view />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useHead } from '@vueuse/head'

export default defineComponent({
  name: 'App',
  setup() {
    useHead({
      title: 'BRICK-ML',
      titleTemplate: '%s',
    })
  },
  created() {},
  methods: {},
})
</script>

<style>
.v-btn__content {
  font-weight: 700;
}

body.resizing-globally * {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

/* @font-face {
  font-family: 'archivo_local';
  src: url('/assets/fonts/archivo/Archivo.ttf');
}
.localFont {
  font-family: 'archivo_local';
} */
</style>
